import { tableFields, fields, formFields } from '../schema'
import PriceLabel from '../../../modules/PriceOffer/components/PriceLabel'
import ZonesTreeSelect from '../../../modules/PriceOffer/components/ZonesTreeSelect'
import DiscountLabel from '../../../modules/PriceOffer/components/DiscountLabel'
import {
  getPriceOffers,
  getPriceOffer,
  deletePriceOffer,
  addPriceOffer,
  updatePriceOffer,
} from '../../../modules/PriceOffer/store/actions'
import arabic_labels from '../../constants/arabic_labels.json'
import { getCompanies } from '../../../modules/Company/store/actions'
import { getCompanyProducts } from '../../../modules/CompanyProduct/store/actions'
import { getProductBuyerCategories } from '../../../modules/BuyerCategory/store/actions'

export const priceOffers = {
  view: {
    get: getPriceOffers,
    delete: deletePriceOffer,
    fields: [
      tableFields.text(arabic_labels['form.name'], 'name'),
      tableFields.text(arabic_labels['form.quantity'], 'optional_1'),
      tableFields.text(arabic_labels['form.package'], 'optional_3'),
      tableFields.text(arabic_labels['form.discount'], 'optional_2'),
      tableFields.text(arabic_labels['form.startDate'], 'starting_date'),
      tableFields.text(arabic_labels['form.endDate'], 'end_date'),
      tableFields.action.edit(),
      tableFields.action.delete(),
    ],
    deleteKey: 'id',
  },
  add: {
    create: addPriceOffer,
    fields: [
      fields.text({
        title: arabic_labels['form.name'],
        dataIndex: 'name',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال الاسم' : true),
      }),
      formFields.select(
        'الشركة',
        'company_id',
        'default',
        { query: getCompanies },
        null,
        ['_id'],
        null,
        null,
        null,
        false,
        [{ required: true, message: 'لا بد من إختيار الشركة' }],
        null,
        null,
        null,
        null,
        (fieldValue) => (!fieldValue ? 'لا بد من إختيار الشركة' : true),
      ),
      formFields.select(
        'المنتج',
        'product_id',
        'default',
        { query: getCompanyProducts },
        null,
        ['_id'],
        null,
        null,
        null,
        false,
        [{ required: true, message: 'لا بد من إختيار المنتج' }],
        'company_id',
        'company',
        null,
        null,
        (fieldValue) => (!fieldValue ? 'لا بد من إختيار المنتج' : true),
      ),
      formFields.select(
        'القطاع',
        'buyer_cat',
        'default',
        { query: getProductBuyerCategories },
        null,
        ['_id'],
        null,
        null,
        null,
        false,
        [{ required: true, message: 'لا بد من إختيار القطاع' }],
        'product_id',
        '_id',
        null,
        null,
        (fieldValue) => (!fieldValue ? 'لا بد من إختيار القطاع' : true),
      ),
      fields.number({
        title: arabic_labels['form.quantity'],
        min: 1,
        dataIndex: 'optional_1',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال الكمية' : true),
      }),
      fields.datePicker({
        title: 'تاريخ البداية',
        dataIndex: 'starting_date',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال تاريخ البداية' : true),
      }),
      fields.datePicker({
        title: 'تاريخ النهاية',
        dataIndex: 'end_date',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال تاريخ النهاية' : true),
      }),
      formFields.select(arabic_labels['form.package'], 'optional_3', 'default', {
        list: [{ key: 'كرتونة', value: 'carton' }, { key: 'عبوة', value: 'unit' }],
      }),
      fields.custom({
        title: 'السعر قبل الخصم',
        dataIndex: 'oldPrice',
        field: PriceLabel,
      }),
      fields.number({
        title: arabic_labels['form.discount'],
        dataIndex: 'optional_2',
        min: 0,
        max: 100,
        allowFractions: true,
        onChange: true,
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال الخصم' : true),
      }),
      fields.custom({
        title: 'السعر بعد الخصم',
        dataIndex: 'newPrice',
        field: DiscountLabel,
      }),
      fields.number({
        title: arabic_labels['form.points'],
        dataIndex: 'points',
        dependentField:'company_id',
        min:0
      }),
      fields.custom({
        title: arabic_labels['form.zone'],
        dataIndex: 'zones',
        field: ZonesTreeSelect,
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال المنطقة' : true),
      }),
    ],
  },
  edit: {
    update: updatePriceOffer,
    get: getPriceOffer,
    fields: [
      fields.text({
        title: arabic_labels['form.name'],
        dataIndex: 'name',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال الاسم' : true),
      }),
      formFields.select(
        'الشركة',
        'company_id',
        'default',
        { query: getCompanies },
        null,
        ['_id'],
        null,
        null,
        null,
        false,
        [{ required: true, message: 'لا بد من إختيار الشركة' }],
      ),
      formFields.select(
        'المنتج',
        'product_id',
        'default',
        { query: getCompanyProducts },
        null,
        ['_id'],
        null,
        null,
        null,
        false,
        [{ required: true, message: 'لا بد من إختيار المنتج' }],
        'company_id',
        'company',
      ),
      formFields.select(
        'القطاع',
        'buyer_cat',
        'default',
        { query: getProductBuyerCategories },
        null,
        ['_id'],
        null,
        null,
        null,
        false,
        [{ required: true, message: 'لا بد من إختيار القطاع' }],
        'product_id',
        '_id',
      ),
      fields.number({
        title: arabic_labels['form.quantity'],
        min: 1,
        dataIndex: 'optional_1',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال الكمية' : true),
      }),
      fields.datePicker({
        title: 'تاريخ البداية',
        dataIndex: 'starting_date',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال تاريخ البداية' : true),
      }),
      fields.datePicker({
        title: 'تاريخ النهاية',
        dataIndex: 'end_date',
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال تاريخ النهاية' : true),
      }),
      formFields.select(arabic_labels['form.package'], 'optional_3', 'default', {
        list: [{ key: 'كرتونة', value: 'carton' }, { key: 'عبوة', value: 'unit' }],
      }),
      fields.custom({
        title: 'السعر قبل الخصم',
        dataIndex: 'oldPrice',
        field: PriceLabel,
      }),
      fields.number({
        title: arabic_labels['form.discount'],
        dataIndex: 'optional_2',
        min: 0,
        max: 100,
        allowFractions: true,
        onChange: true,
        validate: (fieldValue) => (!fieldValue ? 'برجاء إدخال الخصم' : true),
      }),
      fields.custom({
        title: 'السعر بعد الخصم',
        dataIndex: 'newPrice',
        field: DiscountLabel,
      }),
      fields.number({
        title: arabic_labels['form.points'],
        dataIndex: 'points',
        dependentField:'company_id',
        min:0
      }),
      fields.custom({
        title: arabic_labels['form.zone'],
        dataIndex: 'zones',
        field: ZonesTreeSelect,
      }),
    ],
  },
}
